(function () {
    'use strict';

    angular
        .module('app')
        .controller('ConfirmCommunityInactiveController', ConfirmCommunityInactiveController);

    ConfirmCommunityInactiveController.$inject = ['$modalInstance', 'title', 'community'];

    function ConfirmCommunityInactiveController($modalInstance, title, community) {
        var vm = this;
        vm.title = title;

        if (community !== null) {
            vm.name = community;
        }

        vm.onAccept = onAccept;

        function onAccept() {
            $modalInstance.close();
        }
    }
})();
